'use strict';

import React, { useCallback, useState } from 'react'

import { FaCheck } from 'react-icons/fa6'

import { DateTime } from 'luxon'

import DatePicker from '@/Form/V2/DatePicker'
import Input      from '@/Form/V2/Input'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

import Modal from '@Modal/V3/Modal'

import { isTrue, formatNum } from '@root/utility'

const { app } = window;

export default function ECRow ({ data, blank=true, fields, ...props })
{
	const [modal, setModal] = useState({ });
	const [people, setPeople] = useState('');
	const [discount, setDiscount] = useState('');
	const [date, setDate] = useState(DateTime.now().startOf('year').toISODate());
	const [update_modal, setUpdateModal] = useState({ });
	const [status, setStatus] = useState({ });
	const [updating, setUpdating] = useState(false);

	const blank_props = blank === true
	? { target: '_blank', rel: 'noopener noreferrer' }
	: { };

	const link =
	(
		<Link className="u-link-only" { ...blank_props }
			href={ '/gestion-des-CE/les-CE/' + data.id }>
			<span className="u-readers-only">
				Page du CE
			</span>
		</Link>
	);

	const openModal = useCallback(function (e)
	{
		setModal({ open: true, trg: e?.target });
	},
	[]);

	const openUpdateModal = useCallback(function (e)
	{
		setUpdateModal({ open: true, trg: e?.target });
	},
	[]);

	const closeModal = useCallback(function (e)
	{
		setModal({ });
	},
	[]);

	const closeUpdateModal = useCallback(function (e)
	{
		setDate(DateTime.now().startOf('year').toISODate());
		setPeople('');
		setUpdateModal({ });
	},
	[]);

	const modal_link = data.__renewal ?
	(
		<button type="button" className="u-link-only"
			aria-label="Infos renouvellement"
			onClick={ openModal }
		/>
	)
	:
	(
		<button type="button" className="u-link-only"
			aria-label="Renseigner les infos de renouvellement"
			onClick={ openUpdateModal }
		/>
	);

	const renewal = data.__renewal ?
	(
		<>
			<div className={ bemit('c-status-indicator', ['green']) }>
				<div className="c-status-indicator__circle" />
				Oui
			</div>

			{
				isTrue(data.__renewal.budget_modified) ?
				(
					<div className={ bemit('c-filled-chip', ['red']) }>
						Budget modifié
					</div>
				)
				: undefined
			}
		</>
	)
	:
	(
		<div className={ bemit('c-status-indicator', ['grey']) }>
			<div className="c-status-indicator__circle" />
			Non communiqué
		</div>
	);

	const bills_infos = isTrue(data.__renewal?.billed) ?
	(
		<div className="renewal-infos__el u-full-width">
			<div className="renewal-infos__row">
				<strong>Facture Adhésion&nbsp;:</strong>
				{ ' ' }
				<a href={ '/PDF/facture/' + data.__renewal.bill_id }
					target="_blank" rel="noreferrer">
					{ data.__renewal.bill_number }
				</a>
			</div>

			<div className="renewal-infos__row">
				<strong>Facture espace partenaires&nbsp;:</strong>
				<a href={ '/PDF/facture/' + data.__renewal.partner_access_bill_id }
					target="_blank" rel="noreferrer">
					{ data.__renewal.partner_access_bill_number }
				</a>
			</div>
		</div>
	)
	: undefined;

	const renewal_infos = data.__renewal ?
	(
		<div className="renewal-infos">

			{
				isTrue(data.__renewal.budget_modified) ?
				(
					<div className={ bemit('c-filled-chip', ['red']) }>
						Budget modifié
					</div>
				)
				: undefined
			}

			<div className="renewal-infos__el u-full-width">
				<div className="renewal-infos__row">
					<strong>Budget de fonctionnement&nbsp;:</strong>
					{ ' ' }
					{ data.__renewal.budget_data?.label }
				</div>

				<div className="renewal-infos__row">
					<strong>Administrateur ayant renseigné&nbsp;:</strong>
					{ data.__renewal._admin_name }
					{ ' le ' }
					{ DateTime.fromISO(data.__renewal.createdAt).toFormat('dd/MM/yyyy') }
				</div>
			</div>

			<div className="renewal-infos__el">
				<div className="renewal-infos__row">
					<strong>Nombre de bénéficiaires&nbsp;:</strong>
					{ formatNum(data.__renewal.people, '0,0') }
				</div>

				<div className="renewal-infos__row">
					<strong>Nombre de cartes papier&nbsp;:</strong>
					{ formatNum(data.__renewal.physical_cards, '0,0') }
				</div>

				<div className="renewal-infos__row">
					<strong>Nombre de guides papier&nbsp;:</strong>
					{ formatNum(data.__renewal.guides_count, '0,0') }
				</div>
			</div>

			<div className="renewal-infos__el">

				{
					data.__renewal.entry_cost > 0 ?
					(
						<div className="renewal-infos__row">
							<strong>Droit d'entrée&nbsp;:</strong>
							{ formatNum(data.__renewal.entry_cost, '0,0[.]00') }
							&nbsp;€
						</div>
					)
					: undefined
				}

				<div className="renewal-infos__row">
					<strong>Adhésion&nbsp;:</strong>
					{ formatNum(data.__renewal.budget_cost, '0,0[.]00') }
					&nbsp;€
				</div>

				<div className="renewal-infos__row">
					<strong>Accès module partenaire&nbsp;:</strong>
					{ formatNum(data.__renewal.partner_cost, '0,0[.]00') }
					&nbsp;€
				</div>

			</div>

			{ bills_infos }

		</div>
	)
	: undefined;

	const handlePeopleSet = useCallback(function (e)
	{
		setPeople(e.target?.value || '');
	},
	[]);

	const handleDiscountSet = useCallback(function (e)
	{
		setDiscount(e.target?.value || '');
	},
	[]);

	const handleDateSet = useCallback(function ({ e, name, value })
	{
		setDate(value || '');
	},
	[]);

	const saveRenewal = useCallback(function (e)
	{
		setUpdating(true);

		(async function ()
		{
			try
			{
				var response = await request('/EC-renewal/admin-set')
				.config({ keyword: 'action' })
				.post({ EC_id: data.id, people, date, discount });
			}
			catch (update)
			{
				console.error(update);

				setUpdating(false);

				return setStatus(update);
			}

			app.emit('UpdateECsDashboard');

			setUpdating(false);

			setStatus(response);
		})();
	},
	[people, date, data.id, discount]);

	const updating_loader = updating === true ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-green'] } />
	)
	: undefined;

	let output =
	(
		<div className="c-dashboard__row">

			<div className="c-dashboard__cell EnterpriseCommitee-logo_url">

				{
					data.logo?.[0]?.url ?
					(
						<Image className="c-dashboard__cell-img"
							src={ data.logo?.[0]?.url }
						/>
					)
					: undefined
				}

				{ link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-company">

				<div className="c-dashboard__long-text">
					{ data.company }
				</div>

				{ link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-email">

				{ data.email }

				{ link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-address_city">

				{ data.address.city }

				{ link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-__renewal">

				{ renewal }
				{ modal_link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-_has_documents">

				{ isTrue(data._has_documents) ? 'Oui' : undefined }

				{ link }

			</div>

			<div className="c-dashboard__cell EnterpriseCommitee-disabled">

				{ data.disabled === true ? 'Oui' : undefined }

				{ link }

			</div>

			<Modal open={ modal.open === true } onClose={ closeModal }
				trg={ modal.trg }
				title={ 'Renouvellement - ' + data.company }>

				{ renewal_infos }

			</Modal>

			<Modal open={ update_modal.open === true } onClose={ closeUpdateModal }
				trg={ update_modal.trg }
				title={ 'Enregistrer le renouvellement - ' + data.company }>

				<div className="u-flex u-flex-wrap u-gap-15 u-items-start">

					<DatePicker name="date" label="Adhésion à partir du"
						onChange={ handleDateSet }
						value={ date }
						bemit={ ['50%'] }
					/>

					<Input name={ data.id + '[discount]' }
						value={ discount }
						onChange={ handleDiscountSet }
						bemit={ ['50%'] }
						label="Réduction (%)"
					/>

				</div>

				<Input name={ data.id + '[people]' }
					value={ people }
					onChange={ handlePeopleSet }
					bemit={ ['100%'] }
					label="Nombre d'actifs"
					className="u-margin-top-20"
				/>

				{ getFormStatus(status) }

				<button type="button" style={ { marginBottom: 165, marginTop: 20 } }
					className={ bemit('c-btn', ['v2', 'icon', 'green']) }
					onClick={ saveRenewal }>
					<FaCheck className="c-btn__icon" />
					Enregistrer
					{ updating_loader }
				</button>

			</Modal>

		</div>
	);

	return output;
}